export default class PrivatePolicy {
    private static url_info = '/privatepolicy/info';

    public static discover($parent?: JQuery): void {
        $('.js-privatepolicybutton').click((e) => {
            e.preventDefault();

            let $t = $(e.target);
            let type = $t.data('type');

            let url = this.url_info + '?type=' + type;

            (<any> $).fancybox({
                href: url
            });
        });
    }

    public static init(): void {
        $(() => {
            this.discover();
        });
    }
}
